export const GuideList = ({
  items,
  ordered = false,
}: {
  items: string[];
  ordered?: boolean;
}) => {
  const Tag = ordered ? "ol" : "ul";
  return (
    <Tag className="canvaschool-guide-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </Tag>
  );
};
